module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company",
    style: ({
      'height': _vm.height +
        'px'
    })
  }, [_c('p', [_vm._v("This website is owned by FILAMEDIA CO., LIMITED.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b55f8e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/company.vue
// module id = 1327
// module chunks = 1